// extracted by mini-css-extract-plugin
module.exports = {"zIndexToolTip":"13380000","signupButtonWrapper":"styles_signupButtonWrapper__Gcs4l","legalText":"styles_legalText__1I9Nr"};